import * as axios from 'axios';
import CONFIG from '../../config';
import { getAuthHeader } from '../../utils';



export const postJob = (model) => {
    const url = `${CONFIG.BASE_URL}/jobs/add-job`;
    return axios.post(url, model, getAuthHeader())
        .then((response) => {
            return response.data;
        });
  }
  export const getJobsList=(model)=>{
    const url = `${CONFIG.BASE_URL}/jobs/getjoblist`;
    return axios.post(url, model, getAuthHeader())
        .then((response) => {
            return response.data;
        });
  }
  export const getJobsDetails=(model)=>{
    const url = `${CONFIG.BASE_URL}/jobs/getjob-details`;
    return axios.post(url, model, getAuthHeader())
        .then((response) => {
            return response.data;
        });
  }

  export const postUniversityJobApproval=(model)=>{
    const url = `${CONFIG.BASE_URL}/jobs/postuniversitymessage`;
    return axios.post(url, model, getAuthHeader())
        .then((response) => {
            return response.data;
        });
  }

  export const getListUniversityJobApproval=(model)=>{
    const url = `${CONFIG.BASE_URL}/jobs/listuniversitymessage`;
    return axios.post(url, model, getAuthHeader())
        .then((response) => {
            return response.data;
        });
  }